import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {MENU} from '../data/menu'
import {DEFAULT_COUNTRIES} from '../data/default_countries'
import {TARIFICATION} from '../data/tarification'
import {FONCTIONNALITES} from '../data/fonctionnalites'
import router from "../router";

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		baseURL: 'https://infotexto.com/restapi/v1/',
		// baseURL: 'http://localhost/myprojects/infotexto/restapi/v1/',
		menu: MENU,
		default_countries: DEFAULT_COUNTRIES,
		tarification: TARIFICATION,
		fonctionnalites: FONCTIONNALITES,
		validSubscription: true,
		utilisateurId: null,
		utilisateurToken: null,
		nombreSmsPersonnalise: null,
		nombreSmsNonPersonnalise: null,
		token: null,
		monCompteComponent: 'app-mes-donnees',
		smsToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIzNzk1MCIsImlhdCI6MTYwOTk0OTk3OX0.tDo1P92QyZh1Tb65PohSrMAv_tpbnfEzA_wzaSlkkF8',
		prevRoute: null,
		currentRoute: null,
		messageApp: null,
		statusMessage: null,
		timeoutMessage: 5000,
		pays_disponible: [],
	},
	getters: {
		getBaseURL: state => {
			return state.baseURL;
		},
		getDefaultCountries: state => {
			return state.default_countries
		},
		getTarification: state => {
			return state.tarification
		},
		getFonctionnalites: state => {
			return state.fonctionnalites
		},
		getValidSubscription: state => {
			return state.validSubscription
		},
		getMenu: state => {
			return state.menu
		},
		getUtilisateurId: state => {
			return state.utilisateurId
		},
		getMonCompteComponent: state => {
			return state.monCompteComponent
		},
		getNombreSmsPersonnalise: state => {
			return state.nombreSmsPersonnalise
		},
		getNombreSmsNonPersonnalise: state => {
			return state.nombreSmsNonPersonnalise
		},
		getUtilisateurToken: state => {
			return state.utilisateurToken
		},
		getMessageApp: state => {
			return state.messageApp
		},
		getStatusMessage: state => {
			return state.statusMessage
		},
		getTimeoutMessage: state => {
			return state.timeoutMessage
		},
		getPrevRoute: state => {
			return state.prevRoute
		},
		getCurrentRoute: state => {
			return state.currentRoute
		},
		getPaysDisponible: state => {
			return state.pays_disponible
		},
		getTokenSms: state => {
			return state.tokenSms
		},
	},
	mutations: {
		setPrevRoute(state, payload) {
			state.prevRoute = payload
		},
		setCurrentRoute(state, payload) {
			state.currentRoute = payload
		},
		setValidSubscription(state, payload) {
			state.validSubscription = payload
		},
		setMessageApp(state, payload) {
			state.messageApp = payload
		},
		setStatusMessage(state, payload) {
			state.statusMessage = payload
		},
		setTimeoutMessage(state, payload) {
			state.timeoutMessage = payload
		},
		setPaysDisponible(state, payload) {
			state.pays_disponible = payload
		},
		setMonCompteComponent(state, payload) {
			state.monCompteComponent = payload
		},
		setNombreSmsPersonnalise(state, payload) {
			state.nombreSmsPersonnalise = payload
		},
		setNombreSmsNonPersonnalise(state, payload) {
			state.nombreSmsNonPersonnalise = payload
		},
		utilisateurAuth(state, payload) {
			state.utilisateurId = payload.id
			state.utilisateurToken = payload.token
		},
		suppressionUtilisateurAuth(state) {
			state.utilisateurId = null
			state.utilisateurToken = null
		},
	},
	actions: {
		setLogoutTimer({dispatch}){
			setTimeout(() => {
				dispatch('axiosUtilisateurDeconnection')
			}, 3600000)
		},
		changeMessageApp({commit}, payload) {
			commit('setMessageApp', payload.message)
			commit('setStatusMessage', payload.status)
		},
		tryAutoLogin({commit}){
			const id = sessionStorage.getItem('uId')
			const token = sessionStorage.getItem('uToken')
			if(!id && !token) return
			commit('utilisateurAuth', {
				id: id,
				token: token
			})
		},
		axiosUtilisateurDeconnection({commit}) {
			commit('suppressionUtilisateurAuth')
			commit('setMessageApp', 'Vous vous êtes déconnecté de votre compte avec succès')
			commit('setStatusMessage', 'reussite')
			sessionStorage.removeItem('uId')
			sessionStorage.removeItem('uToken')
		},
		axiosUtilisateurAuth({commit, state, dispatch}, data) {
			return axios.post(state.baseURL + data.table + '/', JSON.stringify(data), {})
				.then(response => {
					if (response.status === 200 && response.data.status === 'reussite') {
						commit('utilisateurAuth', {
							id: response.data.data.utilisateur_id,
							token: response.data.data.token
						})
						dispatch('changeMessageApp', {
							status: response.data.status,
							message: response.data.messages,
						})
						dispatch('setLogoutTimer')
						sessionStorage.setItem('uId', response.data.data.utilisateur_id)
						sessionStorage.setItem('uToken', response.data.data.token)
						router.replace(state.prevRoute).then()
					}else {
						commit('setMessageApp', 'Impossible de vous connecter à votre compte !')
						commit('setStatusMessage', response.data.status)
					}
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosRemoveFileData({commit, state, dispatch}, data) {
			return axios.delete(state.baseFileURL + 'remove_file.php', data)
				.then(response => {
					return [true, response.data.message, '']
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
				});
		},
		axiosPostFileData({commit, state, dispatch}, data) {
			return axios.post(state.baseURL +  data.dataForm.table + '/', data.data,
				{headers: {'Content-Type': 'multipart/form-data'}})
				.then(response => {
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosPostData({commit, state, dispatch}, data) {
			return axios.post(state.baseURL + data.table + '/', JSON.stringify(data), {})
				.then(response => {
					if(response.status === 201 && response.data.status === 'reussite'){
						dispatch('changeMessageApp', {
							status: response.data.status,
							message: response.data.messages,
						})
					}else {
						dispatch('changeMessageApp', {
							status: response.data.status,
							message: response.data.messages,
						})
					}
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosGetAllData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + data.table + '/', {})
				.then(response => {
					return response.data;
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosGetOneData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + data.table + '/' + data.table_id)
				.then(response => {
					return response.data;
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosPutData({commit, state, dispatch}, data) {
			return axios.put(state.baseURL + data.table + '/' + data.table_id, JSON.stringify(data), {})
				.then(response => {
					if(response.data.status === 204)
						console.log(response)
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosDeleteData({commit, state, dispatch}, data) {
			return axios.delete(state.baseURL + data.table + '/' + data.table_id)
				.then(response => {
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosGetNumRows({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'total_' + data.table)
				.then(response => response.data)
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				})
		},
		axiosGetNumRowsById({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'total_' + data.table + '/' + data.id)
				.then(response => response.data)
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				})
		},
		axiosGetPaginatedData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'pagination_' + data.table + '/' + data.pageIdx + '/' + data.pageNum)
				.then(response => {
					return response;
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosGetPaginatedDataById({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'pagination_' + data.table + '/' + data.id + '/' + data.pageIdx + '/' + data.pageNum)
				.then(response => {
					return response.data;
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		}
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js